import { render, staticRenderFns } from "./create.vue?vue&type=template&id=f907fd44&scoped=true"
import script from "./create.vue?vue&type=script&lang=js"
export * from "./create.vue?vue&type=script&lang=js"
import style0 from "./create.vue?vue&type=style&index=0&id=f907fd44&prod&scoped=true&lang=css"
import style1 from "./create.vue?vue&type=style&index=1&id=f907fd44&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f907fd44",
  null
  
)

export default component.exports